import { Injectable } from '@angular/core';
import { SynchronizationService } from './synchronization.service';

@Injectable({
  providedIn: 'root'
})
export class MultilingualService {

  constructor(private sync: SynchronizationService) {
    this.sync.with(MultilingualService).commit(done => done());
  }
}
